import React, { useState } from 'react';
import styles from './OnboardingPage.module.css';
import IconCard from '../../components/Iconcard/IconCard.js';
import img1 from "../../assets/images/image1.png";
import img2 from "../../assets/images/image2.png";
import img3 from "../../assets/images/image3.png";
import img4 from "../../assets/images/image4.png";
import cheer from '../../assets/images/chire.png';
import { sendMailFromKlaviyo } from '../../api.js';

const EmailIcon = () => (
  <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.75 1H16.75C17.7125 1 18.5 1.7875 18.5 2.75V13.25C18.5 14.2125 17.7125 15 16.75 15H2.75C1.7875 15 1 14.2125 1 13.25V2.75C1 1.7875 1.7875 1 2.75 1Z" stroke="#949494" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M18.5 2.75L9.75 8.875L1 2.75" stroke="#949494" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const BagIcon = () => (
  <svg width="82" height="82" viewBox="0 0 82 82" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="51.939" cy="31.061" r="28.061" fill="#FEF2F6"/>
    <path d="M63.286 76.5643L58.7461 26.6253C58.729 26.4373 58.6421 26.2624 58.5027 26.1351C58.3632 26.0078 58.1811 25.9373 57.9923 25.9374H51.2604L51.3807 24.6103C51.5528 22.6825 51.2264 20.7427 50.4328 18.9774C49.6392 17.2121 48.405 15.6805 46.8488 14.5298C45.2926 13.379 43.4666 12.6476 41.5463 12.406C39.6259 12.1644 37.6757 12.4205 35.8829 13.1499C34.2539 12.4854 32.4916 12.2127 30.7379 12.3538C28.9842 12.4949 27.2881 13.0458 25.7863 13.9622C24.2844 14.8786 23.0187 16.1349 22.0912 17.6299C21.1636 19.1249 20.6 20.8168 20.4459 22.5694L20.1396 25.9374H12.5932C12.4044 25.9373 12.2224 26.0079 12.0829 26.1352C11.9435 26.2625 11.8567 26.4373 11.8395 26.6253L7.29963 76.5643C7.29009 76.6691 7.30247 76.7746 7.33601 76.8743C7.36954 76.974 7.42349 77.0656 7.4944 77.1432C7.56531 77.2209 7.65163 77.2829 7.74786 77.3254C7.84408 77.3678 7.94809 77.3897 8.05326 77.3897H62.5322C62.6364 77.3867 62.739 77.3627 62.8338 77.3192C62.9286 77.2758 63.0136 77.2137 63.084 77.1367C63.1543 77.0597 63.2084 76.9694 63.2431 76.871C63.2779 76.7727 63.2924 76.6684 63.286 76.5643ZM53.4524 70.1864L46.807 74.8601L51.1171 27.4507H53.4524V70.1864ZM54.2015 71.5098L60.2058 75.8764H47.9934L54.2015 71.5098ZM61.6277 75.0397L54.9657 70.1948V27.4507H57.3015L61.6277 75.0397ZM40.155 13.8309C41.511 13.8309 42.8522 14.1135 44.0929 14.6607C45.3337 15.2079 46.4468 16.0077 47.3612 17.0091C48.2756 18.0104 48.9712 19.1914 49.4038 20.4766C49.8363 21.7618 49.9963 23.1231 49.8734 24.4735L49.741 25.9374H42.7775L42.8978 24.6103C43.0937 22.5606 42.7184 20.4966 41.8137 18.647C40.9089 16.7974 39.5099 15.2343 37.7716 14.1306C38.5509 13.9341 39.3513 13.8335 40.155 13.8309ZM41.2582 25.9374H30.1423L30.436 22.7065C30.5819 21.0294 31.1614 19.4191 32.1177 18.0337C33.074 16.6483 34.3741 15.5354 35.8905 14.8043C37.6881 15.6575 39.18 17.0428 40.1638 18.7724C41.1477 20.5021 41.576 22.4923 41.3907 24.4735L41.2582 25.9374ZM21.953 22.7068C22.0736 21.3045 22.4976 19.9452 23.1958 18.723C23.894 17.5009 24.8496 16.4452 25.9964 15.6291C27.1432 14.8131 28.4537 14.2561 29.8371 13.9969C31.2205 13.7376 32.6438 13.7823 34.0082 14.1278C32.5751 15.0557 31.3726 16.2984 30.4924 17.7613C29.6121 19.2241 29.0773 20.8686 28.9286 22.5694L28.6225 25.9374H21.6595L21.953 22.7068ZM13.2842 27.4507H49.5972L45.1949 75.8764H8.88217L13.2842 27.4507Z" fill="#F47DA5"/>
  </svg>
);

const BoxIcon = () => (
  <svg width="82" height="82" viewBox="0 0 82 82" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="52.7785" cy="31.5127" r="26.5127" fill="#FEF2F6"/>
    <g clipPath="url(#clip0_713_38)">
      <path d="M62.4206 26.9699L33.8564 13.1802C33.6031 13.0581 33.3082 13.0581 33.0551 13.1802L4.49077 26.9699C4.17228 27.1236 3.96991 27.4461 3.96991 27.7998V61.2889C3.96991 61.6425 4.17228 61.9651 4.49077 62.1188L33.055 75.9084C33.1816 75.9695 33.3187 76.0001 33.4557 76.0001C33.5927 76.0001 33.7297 75.9695 33.8564 75.9084L62.4206 62.1188C62.7391 61.9651 62.9415 61.6425 62.9415 61.2889V27.7999C62.9415 27.446 62.739 27.1237 62.4206 26.9699ZM33.4557 15.0335L59.9002 27.7998L52.2345 31.5005C52.186 31.4635 52.1347 31.4293 52.0784 31.4022L25.8136 18.7228L33.4557 15.0335ZM23.7323 19.7648L50.1384 32.5125L44.7301 35.1234L18.335 22.3809L23.7323 19.7648ZM50.7562 34.2607V43.9119L45.7045 46.3507V36.6995L50.7562 34.2607ZM61.0984 60.7106L34.3772 73.6102V42.1678L40.7511 39.0907C41.2094 38.8695 41.4016 38.3186 41.1803 37.8602C40.959 37.402 40.4081 37.2096 39.9497 37.431L33.4557 40.5661L30.9004 39.3324C30.442 39.1109 29.8911 39.3033 29.6698 39.7616C29.4485 40.22 29.6407 40.7709 30.099 40.9922L32.5341 42.1678V73.6102L5.81302 60.7104V29.268L26.1609 39.0911C26.2901 39.1535 26.4266 39.183 26.5609 39.183C26.9034 39.183 27.2325 38.9911 27.3914 38.6619C27.6127 38.2036 27.4205 37.6526 26.9622 37.4313L7.01116 27.7998L16.1659 23.3802L43.8486 36.7444C43.8527 36.75 43.8572 36.755 43.8614 36.7606V47.8191C43.8614 48.1362 44.0244 48.431 44.293 48.5997C44.4422 48.6933 44.6124 48.7406 44.7831 48.7406C44.9197 48.7406 45.0567 48.7103 45.1836 48.649L52.0784 45.3204C52.3969 45.1667 52.5993 44.8443 52.5993 44.4906V33.3711L61.0984 29.2681V60.7106Z" fill="#F47DA5"/>
      <path d="M13.4182 57.1363L9.22633 55.1127C8.76776 54.8912 8.21704 55.0836 7.99575 55.5419C7.77445 56.0003 7.96663 56.5512 8.42495 56.7725L12.6168 58.7961C12.7459 58.8585 12.8824 58.888 13.0167 58.888C13.3593 58.888 13.6884 58.6961 13.8472 58.3669C14.0687 57.9085 13.8765 57.3578 13.4182 57.1363Z" fill="#F47DA5"/>
      <path d="M17.276 54.6251L9.23211 50.7418C8.77367 50.5205 8.22283 50.7127 8.00153 51.1711C7.78036 51.6294 7.97253 52.1804 8.43085 52.4017L16.4748 56.285C16.6039 56.3473 16.7404 56.3769 16.8747 56.3769C17.2173 56.3769 17.5464 56.185 17.7052 55.8558C17.9265 55.3972 17.7344 54.8463 17.276 54.6251Z" fill="#F47DA5"/>
    </g>
    <defs>
      <clipPath id="clip0_713_38">
        <rect width="62.9114" height="62.9114" fill="white" transform="translate(2 13.0886)"/>
      </clipPath>
    </defs>
  </svg>
);
const FlashIcon = ()=>(
  <svg width="53" height="50" viewBox="0 0 53 50" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M10.7833 29.0905C10.7833 29.0905 25.4381 29.1163 28.5623 32.1631C31.6865 35.21 31.4674 50.0001 31.4674 50.0001H31.4739C31.4739 50.0001 31.2484 35.21 34.3791 32.1631C37.5097 29.1163 52.158 29.0905 52.158 29.0905C52.158 29.0905 37.5033 29.0647 34.3791 26.0178C31.2484 22.9774 31.4739 8.18091 31.4739 8.18091H31.4674C31.4674 8.18091 31.6929 22.9709 28.5623 26.0178C25.4316 29.0647 10.7833 29.0905 10.7833 29.0905Z" fill="#F9C442"/>
  <path d="M0 11.595C0 11.595 7.98378 11.6121 9.69299 13.2996C11.4022 14.9871 11.2729 23.1899 11.2729 23.1899C11.2729 23.1899 11.1492 14.9871 12.8528 13.2996C14.5564 11.6121 22.5458 11.595 22.5458 11.595C22.5458 11.595 14.562 11.5778 12.8528 9.89032C11.1492 8.20285 11.2729 0 11.2729 0C11.2729 0 11.3966 8.20285 9.69299 9.89032C7.98941 11.5778 0 11.595 0 11.595Z" fill="#F9C442"/>
  <path d="M6.44165 40.2601C6.44165 40.2601 12.1436 40.2706 13.364 41.4412C14.5843 42.6119 14.4937 48.3121 14.4937 48.3121C14.4937 48.3121 14.4084 42.6171 15.6234 41.4412C16.8384 40.2706 22.5458 40.2601 22.5458 40.2601C22.5458 40.2601 16.8438 40.2495 15.6234 39.0789C14.4084 37.9083 14.4937 32.208 14.4937 32.208C14.4937 32.208 14.579 37.903 13.364 39.0789C12.149 40.2495 6.44165 40.2601 6.44165 40.2601Z" fill="#F9C442"/>
  </svg>
);
const CloseIcon = ()=>(
  <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M24.4697 12.4697C24.7626 12.1768 25.2373 12.1768 25.5302 12.4697C25.8231 12.7626 25.8231 13.2373 25.5302 13.5302L13.5302 25.5302C13.2373 25.8231 12.7626 25.8231 12.4697 25.5302C12.1768 25.2373 12.1768 24.7626 12.4697 24.4697L24.4697 12.4697Z" fill="#333333"/>
  <path d="M36.25 19C36.25 9.47309 28.5269 1.75 19 1.75C9.47309 1.75 1.75 9.47309 1.75 19C1.75 28.5269 9.47309 36.25 19 36.25C28.5269 36.25 36.25 28.5269 36.25 19ZM37.75 19C37.75 29.3553 29.3553 37.75 19 37.75C8.64466 37.75 0.25 29.3553 0.25 19C0.25 8.64466 8.64466 0.25 19 0.25C29.3553 0.25 37.75 8.64466 37.75 19Z" fill="#333333"/>
  <path d="M12.4698 12.4698C12.7444 12.1952 13.1792 12.1778 13.4737 12.4181L13.5304 12.4698L25.5304 24.4698L25.5821 24.5265C25.8225 24.8211 25.805 25.2558 25.5304 25.5304C25.2558 25.805 24.8211 25.8225 24.5265 25.5821L24.4698 25.5304L12.4698 13.5304L12.4181 13.4737C12.1778 13.1792 12.1952 12.7444 12.4698 12.4698Z" fill="#333333"/>
  </svg>
);

const GlobeIcon = () => (
  <svg width="82" height="82" viewBox="0 0 82 82" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="52.2765" cy="31.7235" r="26.7235" fill="#FEF2F6"/>
    <g clipPath="url(#clip0_713_40)">
      <path d="M64.4754 46.1743C63.9658 46.1377 63.5203 46.5229 63.4839 47.0343C62.6403 58.9102 54.7913 68.8168 44.1727 72.8131L51.0918 64.4817C52.3684 62.9447 52.1858 61.525 52.1858 59.5808L54.8272 58.4068C56.231 57.7829 57.1384 56.387 57.1384 54.8506C57.1384 53.3528 55.9197 52.1341 54.4218 52.1341H53.3349L50.9194 47.482C50.1183 45.9391 48.5405 44.9806 46.802 44.9806H41.3781C40.3157 44.9806 39.3168 45.3944 38.5655 46.1456C37.9389 46.7726 36.9738 46.8857 36.2186 46.4212L31.4133 43.464V40.0958H34.1483L35.0999 41.3646C35.8958 42.4255 37.5236 42.3023 38.1516 41.136L42.045 33.9053H44.3172C45.3185 33.9053 46.1331 33.0906 46.1331 32.0894V29.09C47.9087 29.0521 48.5779 26.7361 47.0915 25.7575C38.2209 19.9189 39.1218 20.0807 33.8113 20.0807C33.2987 20.0807 32.8833 20.4962 32.8833 21.0087C32.8833 21.5212 33.2987 21.9367 33.8113 21.9367C38.715 21.9367 37.5671 21.7103 45.9656 27.2385C45.0235 27.3043 44.2771 28.0917 44.2771 29.0501V32.049H42.0212C41.3526 32.049 40.74 32.4148 40.4222 33.0041L36.5473 40.2007C34.828 37.9088 35.4097 38.2397 31.3734 38.2397C30.3719 38.2397 29.5575 39.0543 29.5575 40.0555V43.4863C29.5575 44.1121 29.8885 44.7048 30.4218 45.0328L35.2462 48.0017C36.7365 48.9188 38.6415 48.6951 39.8784 47.4578C40.279 47.0572 40.8118 46.8365 41.3785 46.8365H46.8024C47.8455 46.8365 48.7919 47.4115 49.2726 48.3372L51.6993 53.0111C52.0129 53.6149 52.6305 53.9901 53.3109 53.9901H54.4222C55.6918 53.9901 55.5188 56.0685 54.0739 56.7106L51.4089 57.8952C49.3034 58.8305 51.2199 61.4232 49.6646 63.2959L40.9181 73.8275C40.1899 74.0093 39.4518 74.1645 38.7048 74.2913V71.104C40.6856 65.444 40.6308 65.7119 40.6308 65.2925V62.0725C40.6308 61.3159 40.1539 60.6313 39.444 60.3691L36.2775 59.1996C35.3168 58.8447 34.6714 57.9183 34.6714 56.8941L34.6706 54.8105C35.2553 51.9416 33.6919 49.1083 30.9534 48.0729L24.1301 45.4932L22.6034 38.564C22.4212 37.7384 21.6755 37.1391 20.8298 37.1391H16.6425L14.172 31.6096L14.8453 30.167C15.649 28.445 15.3014 26.3702 13.9801 25.0046L12.7513 23.7339C14.0469 22.4483 15.4595 21.2806 16.9716 20.2481C20.9055 21.921 20.8184 21.9365 21.3118 21.9365H29.4808C29.9933 21.9365 30.4088 21.5209 30.4088 21.0085C30.4088 20.496 29.9933 20.0804 29.4808 20.0804H21.3201L18.8841 19.0445C28.8211 13.3092 41.2231 13.7914 50.7373 20.4184C50.0501 23.2757 52.1702 25.1094 51.546 27.2721C50.5763 30.6316 53.2885 33.4159 55.7506 33.9632C61.4176 35.2226 61.2583 35.2232 61.9545 35.2324C62.7817 37.6395 63.3094 40.1869 63.4897 42.832C63.5245 43.3434 63.9672 43.7305 64.4787 43.6949C64.99 43.6601 65.3763 43.2173 65.3414 42.7059C64.7253 33.6636 60.2869 25.4584 53.3066 19.98C32.448 3.56279 2.06836 18.6739 2.06836 44.8899C2.06836 53.3506 5.36305 61.3046 11.3456 67.2872C17.3282 73.2699 25.2823 76.5646 33.7429 76.5646C50.3689 76.5646 64.1607 63.7001 65.3353 47.1656C65.3716 46.6544 64.9867 46.2104 64.4754 46.1743ZM61.2019 33.2732C54.913 31.8755 55.6389 32.1879 54.3348 31.0913C53.3768 30.2861 52.9821 28.989 53.3292 27.7867C54.038 25.331 52.5085 23.2847 52.4522 21.7054C56.2363 24.7629 59.2682 28.7264 61.2019 33.2732ZM36.8481 74.5446C19.233 76.394 3.92427 62.5157 3.92427 44.8902C3.92439 37.2943 6.78077 30.354 11.4737 25.0833L12.6455 26.2949C13.4355 27.1117 13.6435 28.3523 13.1628 29.382C12.485 30.8344 12.0548 31.422 12.4694 32.3501L14.9579 37.9198C15.2498 38.573 15.9005 38.995 16.6159 38.995H20.7971L22.3216 45.9139C22.4541 46.515 22.877 47.0038 23.4529 47.2215L30.2965 49.8089C32.1787 50.5204 33.2532 52.4679 32.8516 54.4388C32.8035 54.6733 32.8148 54.608 32.8148 56.8939C32.8148 58.6914 33.9476 60.3174 35.6337 60.9405L38.774 62.1004V65.2855C36.7974 70.933 36.848 70.6739 36.848 71.0968V74.5446H36.8481Z" fill="#F47DA5"/>
    </g>
    <defs>
      <clipPath id="clip0_713_40">
        <rect width="63.4118" height="63.4118" fill="white" transform="translate(2 13.1528)"/>
      </clipPath>
    </defs>
  </svg>
);

const data = [
  {
    icon: <BagIcon />,
    title: "Buy or Rent Decor That Fits Your Style",
    description:
      "Shop curated kits and gently-loved party decor you can buy or rent — sustainably and affordably.",
  },
  {
    icon: <BoxIcon />,
    title: "Sell or Rent Out Your Decor with Ease",
    description:
      "List your once-used items in seconds with AI-powered tools that style, price, and promote for you.",
  },
  {
    icon: <GlobeIcon />,
    title: "Celebrate with Less Waste",
    description:
      "Give party decor a second life and help reduce the waste from single-use celebrations.",
  },
];

function WaitlistModal({ open, onClose }) {
  if (!open) return null;
  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalBox}>
        <button className={styles.modalClose} onClick={onClose} aria-label="Close">
          <CloseIcon />
        </button>
        <div className={styles.modalIcon}>
          {/* Confetti/party icon SVG */}
          <img src={cheer} alt='cheer'/>
        </div>
        <div className={styles.modalHeadline}>Thank You for Joining the ReParty Waitlist!</div>
        <div className={styles.modalSubtext}>We're thrilled to have you as part<br/>of the ReParty community.</div>
        <div className={styles.modalDescription}>
          You'll be among the first to explore and enjoy our curated marketplace for buying, selling, and renting gently-loved party decor.
        </div>
        <button className={styles.modalButton} onClick={onClose}>BACK TO HOME</button>
      </div>
    </div>
  );
}

function OnboardingPage() {
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [interest, setInterest] = useState('');
  const images = [img1, img2, img3, img4];
  const [modalOpen, setModalOpen] = useState(false); 
  const [submitted, setSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);

  const handleInterestChange = (value) => {
    setInterest((prev) =>
      prev.includes(value)
        ? prev.filter((item) => item !== value) // Remove if already selected
        : [...prev, value] // Add if not selected
    );
  };
  const handleWaitlistSubmit = async (e) => {
    e.preventDefault();
  
    if (isSubmitting) return;
  
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setError('Please enter a valid email address.');
      return;
    }
  
    setIsSubmitting(true);
    setError(null);
    setSubmitted(false);
  
    const payload = {
      email,
      eventData: {
        properties: {
          productName: 'Awesome T-Shirt',
          price: 29.99,
          quantity: 2,
          category: 'Apparel',
        },
        profileProperties: {
          email,
          phone,
          interests: interest.length > 0 ? interest : ['None'],
          firstName: 'John',
          lastName: 'Doe',
          country: 'USA',
        },
      },
    };
  
    try {
      const data = await sendMailFromKlaviyo(payload);
      setSubmitted(true);
      setEmail("");
      setPhone("");
      setInterest([]);
      setModalOpen(true);  
      setTimeout(() => setSubmitted(false), 5000); 
    } catch (err) { 
      setError(err.response?.data || err.message || 'Failed to subscribe');
    } finally {
      setIsSubmitting(false);
    }
  };
  
  // const handleWaitlistSubmit = (e) => {
  //   e.preventDefault();
  //   setModalOpen(true);
  // };

  return (
    <div className={styles.container}>
      <WaitlistModal open={modalOpen} onClose={() => setModalOpen(false)} />
      <div className={styles.mainWrapper}>
        <div className={styles.content}>
          {/* Left Section */}
          <div className={styles.leftSection}>
            <IconCard brand="logo" />
            <h1 className={styles.headline}>
              Where <span className={styles.highlight}>Party Decor</span><br />
              Gets a Second<br />
              <span className={styles.highlight}>Celebration</span> <FlashIcon />
            </h1>
            <p className={styles.maindescription}>
              ReParty is a new marketplace where you can buy, sell, or rent stylish, gently-loved party decor — and help reduce waste with every celebration.
            </p>
            <div className={styles.waitlistMessage}>
              Be the first to know when we launch!
            </div>
            <form className={styles.form} onSubmit={handleWaitlistSubmit}>
              <div className={styles.inputRow}>
                <div className={styles.emailInputWrapper}>
                  <div className={styles.inputWithIcon}>
                    <EmailIcon />
                    <input
                      className={styles.input}
                      type="email"
                      placeholder="Email Address*"
                      value={email}
                      onChange={e => setEmail(e.target.value)}
                      required
                    />
                  </div>
                </div>
                <div className={styles.emailInputWrapper}>
                  <input
                    className={styles.input}
                    type="number"
                    placeholder="Phone Number"
                    value={phone}
                    onChange={e => setPhone(e.target.value)}
                  />
                  <span className={styles.phoneNote}>
                    Used only for early access or special invites
                  </span>
                </div>
              </div>
              <div className={styles.interestRow}>
                <span className={styles.interestSection}>I'm interested in:</span>
                <div className={styles.checkboxGroup}>
                <label className={styles.checkboxWrapper}>
                    <input
                      type="checkbox"
                      name="interest"
                      value="Selling"
                      className={styles.checkbox}
                      checked={interest.includes('Selling')}
                      onChange={() => handleInterestChange('Selling')}
                    />
                    <span className={styles.checkboxLabel}>Selling</span>
                  </label>
                  <label className={styles.checkboxWrapper}>
                    <input
                      type="checkbox"
                      name="interest"
                      value="Buying"
                      className={styles.checkbox}
                      checked={interest.includes('Buying')}
                      onChange={() => handleInterestChange('Buying')}
                    />
                    <span className={styles.checkboxLabel}>Buying</span>
                  </label>
                  <label className={styles.checkboxWrapper}>
                    <input
                      type="checkbox"
                      name="interest"
                      value="Both"
                      className={styles.checkbox}
                      checked={interest.includes('Both')}
                      onChange={() => handleInterestChange('Both')}
                    />
                    <span className={styles.checkboxLabel}>Both</span>
                  </label>
                </div>
              </div>
              <button className={styles.joinButton} type="submit">
                <span className={styles.joinButtonText}>JOIN THE WAITLIST</span>
                <span className={styles.arrowIcon}>→</span>
              </button>
            </form>
          </div>
          {/* Right Section: Images */}
          <div className={styles.rightSection}>
            <div className={styles.grid}>
              {images.map((img, index) => (
                <div key={index} className={styles.gridItem}>
                  <img src={img} alt={`Party ${index + 1}`} />
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className={styles.howWeWork}>
          <div className={styles.heading}>How ReParty Works?</div>
          <div className={styles.cards}>
            {data.map((item, index) => (
              <div className={styles.card} key={index}>
                <span className={styles.icon}>{item.icon}</span>
                <div className={styles.title}>{item.title}</div>
                <div className={styles.description}>{item.description}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default OnboardingPage;
